import * as router from "react-router-dom";

// Reexport to enable stubbing
export const useNavigate = () => router.useNavigate();
